import * as yup from 'yup';

import { OPTIONS_STATUS_LOGBOOK } from './Data.conf';

const CommonFields = {
  schema: yup.object({
    status_logbook: yup.string().nullable().required('Status is required'),
  }),
  defaultValues: {
    status_logbook: null,
  },
  fields: [],
};

export const ActionConf = {
  DEFAULT: {
    ...CommonFields,
    fields: [
      {
        id: 'status_logbook',
        name: 'status_logbook',
        type: 'select-custom',
        label: 'Status',
        required: true,
        options: OPTIONS_STATUS_LOGBOOK?.DEFAULT,
        xs: 12,
        sm: 6,
      },
    ],
  },
  DELIVERIES: {
    ...CommonFields,
    fields: [
      {
        id: 'status_logbook',
        name: 'status_logbook',
        type: 'select-custom',
        label: 'Status',
        required: true,
        options: OPTIONS_STATUS_LOGBOOK?.DELIVERIES,
        xs: 12,
        sm: 6,
      },
    ],
  },
  SHIPPING: {
    ...CommonFields,
    fields: [
      {
        id: 'status_logbook',
        name: 'status_logbook',
        type: 'select-custom',
        label: 'Status',
        required: true,
        options: OPTIONS_STATUS_LOGBOOK?.SHIPPING,
        xs: 12,
        sm: 6,
      },
    ],
  },
};
